import types from "./types";



// coaching list
export const getAllCoaching = (payload) => ({ type: types.COACHING_LIST, payload })
export const getAllCoachingResponse = (payload) => ({ type: types.COACHING_LIST_RESPONSE, payload })
export const getAllCoachingClear = () => ({ type: types.COACHING_LIST_CLEAR })






